import { HOW_TO_BUY_ITEMS } from "./constants";
import { HowToBuyItem } from "./HowToBuyItem";

export const HowToBuyList = () => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
    {HOW_TO_BUY_ITEMS.map(({ id, ...link }) => (
      <HowToBuyItem key={id} {...link} />
    ))}
  </div>
);
